<div class="container-fluid">
    <div class="row">
      <div class="square day-instruction"></div>
      <div class="ml-10">Instruction active for today</div>
      <div class="ml-10 square applied-in-ppa"></div>
      <div class="ml-10">Instruction applied in EDT</div>
      <div class="ml-10 square isOverride"></div>
      <div class="ml-10">Instruction is override and not applied</div>
    </div>
    <div class="row">
      <table id="tblInstructions" class="nj-table nj-table--hover nj-table--striped nj-cursor">
        <thead>
          <tr [style]="'background-color: #d8d8d8'" class="pointer">
            <th (click)="DataGridHelper.SortData('notifiedOn')">Notified On</th>
            <th (click)="DataGridHelper.SortData('units')">Unit</th>
            <th (click)="DataGridHelper.SortData('startDate')">Start Date</th>
            <th (click)="DataGridHelper.SortData('endDate')">End Date</th>
            <th (click)="DataGridHelper.SortData('isOverwrite')">Is Overwrite</th>
            <th (click)="DataGridHelper.SortData('strike')">Strike</th>
            <th (click)="DataGridHelper.SortData('fixedCosts')">Fixed Costs</th>
            <th (click)="DataGridHelper.SortData('negativePriceTrigger')">Neg. Price Trigger</th>
            <th (click)="DataGridHelper.SortData('comments')">Comments</th>
            <th (click)="DataGridHelper.SortData('reporter')">Reporter</th>
            <th (click)="DataGridHelper.SortData('status')">Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for(instruction of DataGridHelper.CurrentPageData; track instruction.instructionId; let i = $index) {
          <tr [class.isOverride]="instruction.isOverride" [class]="GetClass(instruction.startDate, instruction.endDate, instruction.isAppliedInPPA)">
            <td>{{DateFormatHelper.GetDisplayDateOnly(instruction.notifiedOn)}}</td>
            <td>{{instruction.units}}</td>
            <td>{{DateFormatHelper.GetDisplayDateOnly(instruction.startDate)}}</td>
            <td>{{instruction.endDate ? DateFormatHelper.GetDisplayDateOnly(instruction.endDate) : ""}}</td>
            <td>{{instruction.isOverride == true ? "Yes" : "No" }}</td>
            <td>{{instruction.strike}}</td>
            <td>{{instruction.fixedCosts}}</td>
            <td>{{instruction.negativePriceTrigger}}</td>
            <td>{{instruction.comments}}</td>
            <td>{{instruction.reporter}}</td>
            <td>{{instruction.status}}</td>
            <td>
              <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="ViewInstruction(instruction.instructionId)">
                View
              </nj-button>
              @if(UserData.HasMorayEastAccess)
              {
                &nbsp;
              <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="CopyToNew(instruction.instructionId)">
                Copy
              </nj-button>
              }
            </td>
          </tr>
        }
        </tbody>
      </table>
      <nj-pagination
        [count]="DataGridHelper.PageCount" 
        [shouldMinify]="true" (selectedItem)="DataGridHelper.ChangePage($event)"></nj-pagination>
    </div>
  </div>